<template>
    <div class="contenedor_modal">
        <div class="contenedor_modal_cuerpo">
            <div class="contenedor_modal_cabecera">
                <b-button type="button" size="sm" variant="danger" @click="cerrar"><i
                        class="fas fa-times"></i></b-button>
            </div>

            <b-container fluid="">
                <b-row>
                    <div class="col-sm-12 mt-3">
                        <h3>
                            Actualizar
                        </h3>
                    </div>
                    <div class="col-sm-12 mt-3">
                        <label for="" class="form-label">Nombre</label>
                        <input type="text" id="campo_sucursal_nombre_editar" autocomplete="off"
                            class="form-control form-control-sm" v-model="nombre">
                    </div>
                    <div class="col-sm-6 mt-3">
                        <label for="" class="form-label">Cantidad por lotes</label>
                        <input type="number" step="0.01" min="1" class="form-control form-control-sm"
                            v-model="cantidad_por_lotes">
                    </div>
                    <div class="col-sm-6 mt-3">
                        <label for="" class="form-label">Unidades</label>
                        <input type="number" step="0.01" min="1" class="form-control form-control-sm"
                            v-model="unidades">
                    </div>
                    <div class="col-sm-12 mt-3 mb-3">
                        <button type="button" class="btn btn-sm btn-block btn-outline-dark"
                            @click="actualizar">Actualizar</button>
                    </div>
                </b-row>
            </b-container>
        </div>
    </div>
</template>

<script>
    import { minix } from '@/components/functions/alertas'
    import { mapActions } from 'vuex'
    export default {
        name: 'Actualizar',
        props: ['item'],
        data() {
            return {
                nombre: '',
                cantidad_por_lotes: '',
                unidades: '',
            }
        },
        methods: {
            cerrar() {
                this.$emit('salir')
            },
            async actualizar() {
                if (this.nombre == '' || this.cantidad_por_lotes == '' || this.unidades == '') {
                    minix({ icon: 'error', mensaje: 'Todos los campos son obligatorios', tiempo: 3000 })
                } else {
                    let f = {
                        api: `unidades/${this.item.documentId}`,
                        formulario: {
                            descripcion: this.nombre.toUpperCase().trim(),
                            cantidad_por_lotes: this.cantidad_por_lotes,
                            unidades: this.unidades
                        }
                    }

                    await this.actualizar_data(f)
                    await this.obtener_unidades()

                    this.cerrar()
                }
            },
            ...mapActions(['actualizar_data', 'obtener_unidades'])
        },
        mounted() {
            this.nombre = this.item.descripcion
            this.cantidad_por_lotes = this.item.cantidad_por_lotes
            this.unidades = this.item.unidades

            document.getElementById('campo_sucursal_nombre_editar').focus()
        },
    }
</script>

<style></style>